module.exports = __webpack_public_path__ + "static/media/custom_employees-import.212d7ee1.csv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/custom_employees-import.csv
// module id = ./src/assets/custom_employees-import.csv
// module chunks = 11